import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

import { AppRoutes } from '@/constants/appRoutes'
import { LocalStorageKey } from '@/constants/localStorageKeys'
import { PUBLIC_ROUTES } from '@/hooks/StatusGuard/statusGuardConfig'
import { selectHasToken } from '@/store/api/Auth/Auth.selector'
import { setSession } from '@/store/api/Auth/Auth.slice'
import localStorageService from '@/utils/localStorage'

import { useAppDispatch, useAppSelector } from '../redux'

export const useCheckSession = () => {
  const location = useLocation()
  const hasSession = useAppSelector(selectHasToken)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const currentPath = location.pathname
  const isPublicRoute = PUBLIC_ROUTES.includes(currentPath as AppRoutes)

  useEffect(() => {
    if (isPublicRoute) return

    if (!hasSession) {
      const result = localStorageService.get(LocalStorageKey.token)
      if (result) {
        dispatch(setSession({ token: result }))
      }
    }
  }, [hasSession, dispatch])

  useEffect(() => {
    if (isPublicRoute) return

    if (!hasSession) {
      const result = localStorageService.get(LocalStorageKey.token)
      if (!result) {
        toast.info(t('feedback.toast.tokenExpired'))
        navigate(AppRoutes.login)
      }
    }
  }, [hasSession, t, navigate])
}
